import { Box } from '@mui/material';
import React from 'react';
import avatar from '../assets/ksim/avatar-2.svg';

const FaqAvatar = () => (
  <Box
    component="img"
    src={avatar}
    sx={{
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      margin: 'auto',
      width: '100px',
      height: '100px;',
    }}
  />
);

export default FaqAvatar;
